module.exports = __webpack_public_path__ + "02.66f60b07.png";